/* eslint-disable no-shadow */
export enum ErrorMessages {
  None = '',
  Loading = 'Unable to load todos',
  EmptyTitle = 'Title should not be empty',
  Add = 'Unable to add a todo',
  Delete = 'Unable to delete a todo',
  Update = 'Unable to update a todo',
}
